var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"55ec26edde0cf7a5aaed95e8b6f5379147812b7d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["doggie-watcher@delta-labs"]={id:"55ec26edde0cf7a5aaed95e8b6f5379147812b7d"};
      